import Vue from 'vue'
import Vuex from 'vuex'


import WmsInventoryModule from './wms_inventory_module'
import WmsProductModule from './wms_product_module'
import WmsStorageModule from './wms_storage_module'
import WmsPartnerModule from './wms_partner_module'
import WmsPromotionModule from './wms_promotion_module'
import AuthModule from './auth_module'
import PlatformTiktokModule from './platform_tiktok_module'
import PlatformLazadaModule from './platform_lazada_module'
import PlatformShopeeModule from './platform_shopee_module'
import PlatformModule from './platform_module'

import OrderMoudle from './order_module'
import ProductMoudle from './product_module'
import ProductCategoryMoudle from './product_category_module'
import PackingModule from './packing_module'
import CustomerModule from './customer_module'
import ReportModule from './report_module'
import PaymentMethodMoudle from './payment_method_module'
import SaleChannelMoudle from './sale_channel_module'
import UserModule from './user_module'
import TeamModule from './team_module'
import DepartmentModule from './department_module'
import CouponModule from './coupon_module'
import MemberModule from './member_module'
import POModule from './po_module'
import PlatformStatementModule from './platform_statement_module'
import AccountModule from './account_module'
import KOLModule from './kol_module'
import AppCatalogCategoryModule from './app_catalog_category_module'
import AppCatalogProductModule from './app_catalog_product_module'
import AppCatalogCampaignModule from './app_catalog_campaign_module'
import AppCatalogPromotionBundleModule from './app_catalog_promotion_bundle_module'
import AppCatalogCouponTemplateModule from './app_catalog_coupon_template_module'
import AppCatalogWmsProductModule from './app_catalog_wms_product_module'
import ShippingTierModule from './shipping_tier_module'
import MemberLevelModule from './member_level_module'
import AgentCommissionModule from './agent_commission_module'
import IssueReportModule from './issue_report_module'
import MenuPrefModule from './menu_pref_module'
import PosModule from './pos_module'


import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const modules = {
    Auth: AuthModule,
    WmsInventory: WmsInventoryModule,
    WmsProduct: WmsProductModule,
    WmsStorage: WmsStorageModule,
    WmsPartner: WmsPartnerModule,
    WmsPromotion: WmsPromotionModule,
    Tiktok: PlatformTiktokModule,
    Shopee: PlatformShopeeModule,
    Lazada: PlatformLazadaModule,
	Platform: PlatformModule,

	Order: OrderMoudle,
	Product: ProductMoudle,
	ProductCategory: ProductCategoryMoudle,
	SaleChannel: SaleChannelMoudle,
	PaymentMethod: PaymentMethodMoudle,
	Packing: PackingModule,
	Customer: CustomerModule,
	Report: ReportModule,
	User: UserModule,
	Team: TeamModule,
	Department: DepartmentModule,
	Coupon: CouponModule,
	Member: MemberModule,
	PO: POModule,
	PlatformStatement: PlatformStatementModule,
	Account: AccountModule,
	KOL: KOLModule,
    AppCatalogCategory: AppCatalogCategoryModule,
    AppCatalogProduct: AppCatalogProductModule,
    AppCatalogCampaign: AppCatalogCampaignModule,
    AppCatalogPromotionBundle: AppCatalogPromotionBundleModule,
    AppCatalogCouponTemplate: AppCatalogCouponTemplateModule,
    AppCatalogWmsProduct: AppCatalogWmsProductModule,
    ShippingTier: ShippingTierModule,
    AgentCommission: AgentCommissionModule,
    MemberLevel: MemberLevelModule,
    IssueReport: IssueReportModule,
    menuPref: MenuPrefModule,
    Pos: PosModule,
}

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState({
	paths: ['Auth', 'menuPref'],
  })]
})
